export const ARCHIVE_OPTION = 'ARCHIVE';
export const UNARCHIVE_OPTION = 'UNARCHIVE';
export const MARK_AS_READ_OPTION = 'MARK_AS_READ';
